export default __webpack_public_path__ + "static/media/limontrello.a9d47e7c.png";